export const SAVE_USER_PROFILE = 'SAVE_USER_PROFILE';
export const SAVE_USER_CURRENCY = 'SAVE_USER_CURRENCY';
export const SAVE_USER_EXCHANGE_RATE = 'SAVE_USER_EXCHANGE_RATE';
export const SAVE_USER_OOO_STATUS = 'SAVE_USER_OOO_STATUS';
export const SAVE_COMPANY_EXCHANGE_RATE = 'SAVE_COMPANY_EXCHANGE_RATE';
export const SAVE_COMPANY_CURRENCY = 'SAVE_COMPANY_CURRENCY';
